import {
	FormControl,
	FormGroup
}                             from '@angular/forms';
import {
	LegalFormEnum,
	OrganizationStatusEnum
}                             from '@app/modules/organization/models/organization.model';
import {
	IAddressForm,
	IAddressFormValues
}                             from '@shared/forms/address-form/address-form.model';
import { INaturalPersonForm } from '@shared/forms/natural-person-form/natural-person-form.model';

// ENUMS #############################################################
export enum OrganizationFormModeEnum {
	NATURAL_PERSON = 'naturalPerson',
	OTHER_LEGAL_FORMS = 'otherLegalForms'
}

// INTERFACES ########################################################
export interface IOrganizationForm {
	addressData: FormGroup<IAddressForm>;
	detailedDescription: FormControl<string>;
	businessIdentificationNumber: FormControl<string>;
	etag: FormControl<string>;
	hasChildren: FormControl<boolean>;
	id: FormControl<string>;
	identificationNumber: FormControl<string>;
	legalForm: FormControl<LegalFormEnum>;
	name: FormControl<string>;
	naturalPerson: FormGroup<INaturalPersonForm>;
	organizationIdentifier: FormControl<string>;
	parentOrgId: FormControl<string>;
	status: FormControl<OrganizationStatusEnum>;
	taxableEntity: FormControl<boolean>;
	taxNumber: FormControl<string>;
	tenantId: FormControl<string>;
	vatId: FormControl<string>;
	website: FormControl<string>;
}

export interface OrganizationFormValues {
	addressData: IAddressFormValues;
	detailedDescription: string;
	businessIdentificationNumber: string;
	etag: string;
	hasChildren: boolean;
	id: string;
	identificationNumber: string;
	legalForm: LegalFormEnum;
	name: string;
	organizationIdentifier: string;
	parentOrgId: string;
	status: OrganizationStatusEnum;
	taxableEntity: boolean;
	taxNumber: string;
	tenantId: string;
	vatId: string;
	website: string;
}


// TYPES #############################################################
export type OrganizationFormProp = ( keyof OrganizationFormValues );
export type OrganizationFormProps = OrganizationFormProp[];


// ENTITIES ##########################################################
